import { render, staticRenderFns } from "./NinjaForm.vue?vue&type=template&id=1f6a09c0&"
import script from "./NinjaForm.vue?vue&type=script&lang=js&"
export * from "./NinjaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports